<template>
  <nav>
    <v-card height="715" flat color="rgba(0,0,0,0)" style="border-radius: 10px;" class="">
      <v-card class="card1 ml-3 mr-3 mt-2">
        <v-carousel height="270" hide-delimiters :cycle="false">
          <v-carousel-item v-for="(item,i) in photos" :key="i" :src="item"></v-carousel-item>
        </v-carousel>
      </v-card>
      <v-card class="card2 pl-3 pr-3 pb-2">
        <v-card class="card3" flat>
          <center>
            <div style="padding-top: 255px; font-size: 18px;">
              
              <v-card class="mt-3 mb-4 ml-1 mr-1" flat style="border-radius: 50px;" height="70px" color="grey lighten-3">
                
                  <v-container fill-height style="padding: 0px; margin: 0px;">
                  <v-avatar size="90" class="">
                    <v-img
                      :src="posted_by.avatar"
                    />
                  </v-avatar>
                  <span class="ml-3 font-weight-light" style="font-size: 22px;">
                    {{ posted_by.name }}
                  </span>
                  </v-container>
                
              </v-card>

              <span class="headline green--text stopflow">{{item_name}}</span>
              <v-divider class="mb-2" />
              <span>Price Marked: </span>
              <span class="green--text font-weight-bold"> &#8377;{{marked_price}}</span>
							<br/>
							<span>Category: </span>
							<span class="green--text font-weight-bold">{{category}}</span>
              <br>
              <v-text-field :disabled="alreadyInterested || alreadyAccepted" v-model="bid" label="Bidding Price" required color="black" class="ml-4 mr-4"></v-text-field>
              <v-btn large flat color="success" @click="addBid" :disabled="alreadyInterested || alreadyAccepted">{{text}}</v-btn>
            </div>
          </center>

          
        </v-card>
      </v-card>
    </v-card>
  </nav>
</template>

<script>
import firebase from "firebase";

export default {
  props: {
    alreadyInterested : Boolean,
    alreadyAccepted : Boolean,
    item_name: String,
    category: String,
    marked_price: Number,
    photos: Array,
    posted_by: Object,
    postId: String,
    interested : Array,
    accepted : Array
  },
  mounted(){
    var vm = this;
    var uid = firebase.auth().currentUser.uid;
    if (vm.alreadyInterested){
      vm.interested.forEach( function(element, index) {
        if (element.uid==uid) {
          vm.bid=element.bid;
          vm.text="Interested"
        }
      });
    }
    if (vm.alreadyAccepted) {
      vm.accepted.forEach( function(element) {
        if (element.uid==uid) {
          vm.bid=element.bid;
          vm.text="accepted"
        }
      });
    }
  },

  data() {
    return {
      text : "Interested",
      bid: this.marked_price,
    };
  },

  methods: {
    addBid(){
      var newInterested = [],
        username = "",
        useravatar = "",
        userInterested = [];
      const db = firebase.firestore();
      var vm = this;
      vm.alreadyInterested = !vm.alreadyInterested;
      db.collection("users")
      .doc(firebase.auth().currentUser.uid)
      .get()
      .then(function(doc) {
        username = doc.data().name;
        useravatar = doc.data().avatar;
        userInterested = doc.data().interested;
        userInterested.push({
          id: vm.postId,
          bid: Number(vm.bid)
        });
        db.collection("users")
        .doc(firebase.auth().currentUser.uid)
        .update({
          interested: userInterested
        })
        .then(function() {
          db.collection("posts_buy")
          .doc(vm.postId)
          .get()
          .then(function(postDoc) {
            newInterested = postDoc.data().interested;
            newInterested.push({
              uid: firebase.auth().currentUser.uid,
              name: username,
              avatar: useravatar,
              bid: Number(vm.bid),
            });
            db.collection("posts_buy")
            .doc(vm.postId)
            .update({
              interested: newInterested
            })
          });
        });
      });
    }
  }
};
</script>

<style scoped>
.card1 {
  border-radius: 10px;
  position: relative;
  z-index: 1;
  top: 0px;
}
.card2 {
  border-radius: 10px;
  position: relative;
  bottom: 240px;
  z-index: 0;
}
.card3 {
  border-radius: 0px 0px 10px 10px;
  z-index: 0;
}
.scroll {
  overflow-y: auto;
}
.stopflow {
  display: inline-block;
  text-overflow: ellipsis;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
}
</style>